<template>
  <div>
    <iframe :src="campaignModalUrl"
            style="position:fixed; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"></iframe>
  </div>
</template>

<script>
import Logo from '@/views/landing/specialCampaign/components/Logo'
import dialog from '@/components/mixins/dialog'
import Dialog from '@/views/landing/specialCampaign/components/Dialog'
import CountdownTime from '@/views/landing/specialCampaign/components/CountdownTime'
import project from '@/project'
import messages from '@/views/landing/specialCampaign/locales/all.json'
import cookies from '@/cookies'
import {mapState} from 'vuex'

export default {
  name: 'SpecialCampaingDialog',
  mixins: [dialog],
  components: {
    Logo,
    Dialog,
    CountdownTime
  },
  i18n: {messages},
  props: {},
  data() {
    return {
      project
    }
  },
  computed: {
    ...mapState('profile', ['currentUser', 'isFollower']),
    ...mapState('preferences', ['darkTheme']),
    ...mapState('application', ['isMobile']),
    campaignModalUrl() {
      if (project.isDevelop) {
        return `https://develop.${project.project}.com/campaigns/promo/${project.campaign.fileName}/modal.html?follower=${this.isFollower}`
      }
      return `https://${project.project}.com/campaigns/promo/${project.campaign.fileName}/modal.html?follower=${this.isFollower}`
    },
    getSrc() {
      return require(`./resources/cabecera_${this.isMobile}_${this.$i18n.locale}.svg`)
    },
    isFemale() {
      return this.currentUser.tags.filter((t) => t.section === 'gender')[0].name === 'female'
    },
    isDark() {
      return this.project.theme === 'dark' || this.darkTheme
    },
    bg() {
      const lang = this.$i18n.locale === 'es' ? 'es' : 'en'
      const device = this.isMobile ? 'mb' : 'pc'
      const typeProfile = this.isFollower ? 'follower' : 'creator'
      return `bg_${lang}_${device}_${typeProfile}`
    }
  },
  created() {
    const root = document.documentElement
    var baseColor = '#f71953'
    if (project.project === 'scatbook') {
      baseColor = '#f47b03'
    }
    if (project.project === 'loverfans') {
      baseColor = '#f71953'
    }
    if (project.project === 'darkfans') {
      baseColor = '#f40303'
    }
    root.style.setProperty('--unnamed-color-base', baseColor)
  },
  methods: {
    controllerMessage(event) {
      if (event.data === 'doNotShowMore') {
        this.notShow()
      }
      if (event.data === 'close') {
        this.close()
      }
    },
    close() {
      this.$emit('close')
    },
    goTo() {
      if (this.isFollower) {
        window.location.href = `https://${this.project.project}.com/campaigns/promoverano/index.html`
        /* if (this.project.project === 'loverfans') {
          this.$router.push('/special/nextDoor/home')
        } else {
          this.$router.push({ name: 'stars_discover' })
        } */
      } else {
        window.location.href = `https://${this.project.project}.com/campaigns/academy/promoverano/index.html`
        /*  if (this.project.project === 'loverfans') {
           this.$router.push('/academy/chick_next_door')
         } else {
           this.$router.push({ name: 'resources' })
         } */
      }
    },
    notShow() {
      cookies.set('hiddenModalCampaign', true)
      this.close()
    }
  },
  mounted() {
    window.addEventListener('message', this.controllerMessage);
  }
}
</script>

<style lang="scss">
@import "./_styles";

hr {
  width: 100%;
  height: 0;
  border: medium none;
  border: 1px dashed var(--unnamed-color-ffffff) !important;
  opacity: 0.6;
}

/*.title1 {
  color: var(--unnamed-color-ffffff);
  text-align: center;
  font: normal normal 900 16px/24px Montserrat;
  letter-spacing: 0px;
}*/

/*.title2 {
  color: var(--unnamed-color-ffffff);
  text-align: center;
  font: normal normal 900 32px/39px Montserrat;
  letter-spacing: 0px;
}*/

.text1 {
  color: #FFA906;
  text-align: center;
  /*font-weight: bold;
  font-family: Baskerville;
  font-size: 60px;*/
  font: normal normal bold 63px/73px Baskerville !important;
}

.text2 {
  text-align: center;
  font-weight: bold;
  font: normal normal bold 63px/73px Baskerville !important;
  color: #FFFFFF;
}

.text3 {
  color: #FFA906;
  font-weight: bold;
  text-align: center;
  font-family: Baskerville;
  font-size: 24px;
  letter-spacing: 0px;
  text-transform: uppercase;
}

.text4 {
  color: white;
  text-align: center;
  font-family: Baskerville;
  font-size: 24px;
  letter-spacing: 0px;
  text-transform: uppercase;
}


.buton-contnue_dialog {
  width: 400px !important;
  height: 40px !important;
  margin: 0 32px;
  color: white !important;
  font-weight: bold !important;
  font-family: Montserrat !important;
  font-size: 18px !important;
  border-radius: 127px !important;
  opacity: 1;
  box-shadow: 0px 3px 6px #00000066;

  &.mobile {
    width: 319px !important;
  }
}

.margin-top-button {
  margin-top: 264px;

  &.mobile {
    margin-top: 488px;
  }
}

.bg_es_pc_follower {
  background: url(./resources/promoverano/Modal-verano-ES-pc.svg) no-repeat center center;
  background-size: cover;
  border: 2px solid #FFFFFF !important;
  //border-radius: 13px;
  opacity: 1;
}

.bg_en_pc_follower {
  background: url(./resources/promoverano/Modal-verano-EN-pc.svg) no-repeat center center;
  background-size: cover;
  border: 2px solid #FFFFFF !important;
  //border-radius: 13px;
  opacity: 1;
}

.bg_es_mb_follower {
  background: url(./resources/promoverano/Modal-verano-EN-mobile.svg) no-repeat center center;
  background-size: cover;
  height: 658px;
  min-height: 380px;
  border: 2px solid #FFFFFF !important;
  opacity: 1;
}

.bg_en_mb_follower {
  background: url(./resources/promoverano/Modal-verano-EN-mobile.svg) no-repeat center center;
  background-size: cover;
  height: 658px;
  min-height: 380px;
  border: 2px solid #FFFFFF !important;
  opacity: 1;
}

.bg_es_pc_creator {
  background: url(./resources/promoverano/Modal-verano-creadoras-ES-pc.svg) no-repeat center center;
  background-size: cover;
  border: 2px solid #FFFFFF !important;
  //border-radius: 13px;
  opacity: 1;
}

.bg_en_pc_creator {
  background: url(./resources/promoverano/Modal-verano-creadoras-EN-pc.svg) no-repeat center center;
  background-size: cover;
  border: 2px solid #FFFFFF !important;
  //border-radius: 13px;
  opacity: 1;
}

.bg_es_mb_creator {
  background: url(./resources/promoverano/Modal-verano-creadoras-ES-mobile.svg) no-repeat center center;
  background-size: cover;
  height: 658px;
  min-height: 380px;
  border: 2px solid #FFFFFF !important;
  opacity: 1;
}

.bg_en_mb_creator {
  background: url(./resources/promoverano/Modal-verano-creadoras-EN-mobile.svg) no-repeat center center;
  background-size: cover;
  height: 658px;
  min-height: 380px;
  border: 2px solid #FFFFFF !important;
  opacity: 1;
}

.link {
  color: white;
  cursor: pointer;
  text-decoration: underline;
}

.img {
  width: 100%;
  max-width: fit-content;
}

.img-center {
  width: 45px;
  height: 61px;
  max-width: fit-content;
}

.content-logo {
  display: grid;
  place-items: center;
}

.line {
  width: 22px;
  height: 0px;
  /* UI Properties */
  border: 2px solid transparent;
  opacity: 1;
}

.content-title8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.banda {
  width: 352px;
}

.text-first {
  font: 30px/28px var(--unnamed-font-family-montserrat) !important;
  color: #000000 !important;
}

.text-second {
  font: 47px/36px var(--unnamed-font-family-montserrat) !important;
  color: #000000 !important;
}

.text-third {
  font-size: 24px;
  font-family: Montserrat-Black !important;
  color: #000000 !important;
}

.text-fourth {
  font: 47px/18px var(--unnamed-font-family-montserrat) !important;
  color: #000000 !important;

  b {
    color: #DF3856;
  }
}

.text-end {
  font: 17px/14px var(--unnamed-font-family-montserrat);
}

.hearts {
  margin-top: 24px;
  margin-bottom: 24px;
}

.text-sixth {
  font-size: 28px;
  font-family: Montserrat-Black !important;
  color: #000000 !important;
}

@media (max-width: 700px) {
  .hide {
    display: none;
  }

  .bg {
    background-color: #fff !important;
    // background: url(./resources/fondo_modal.svg) no-repeat center right;
    background-size: cover;
    min-height: 380px;
    //border: 2px solid var(--unnamed-color-ffffff);
    //background: transparent linear-gradient(20deg, #F0A500 0%, #E45826 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 8px 12px #0000008F;
    border: 2px solid #FFFFFF;
    //border-radius: 13px;
    opacity: 1;
  }

  .bg-mobile {
    background-color: #292929 !important;
    // background: url(./resources/fondo_modal_mobile.svg) no-repeat center right;
    background-size: cover;
    min-height: 380px;
    //border: 2px solid var(--unnamed-color-ffffff);
    //background: transparent linear-gradient(20deg, #F0A500 0%, #E45826 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 8px 12px #0000008F;
    border: 2px solid #292929 !important;
    //border-radius: 13px;
    opacity: 1;
  }

  .text-first {
    font: 28px var(--unnamed-font-family-montserrat) !important;
    color: #F9E1E1 !important;
  }

  .text-second {
    font: 30px var(--unnamed-font-family-montserrat) !important;
    color: #F9E1E1 !important;
  }

  .text-third {
    font-size: 30px !important;
    font-family: Montserrat-Black !important;
    color: #000000 !important;
    margin-bottom: 8px;
  }

  .text-fourth {
    font: 18px var(--unnamed-font-family-montserrat) !important;
    color: #000000 !important;

    b {
      color: #DF3856;
    }
  }

  .text-fifth {
    font-size: 20px;
    font-family: Montserrat;
    color: #000000;
  }

  .text-end {
    font: 14px var(--unnamed-font-family-montserrat);
  }
  .text1 {
    font-size: 18px !important;
  }
  .text2 {
    font: normal normal 900 17px/22px Montserrat !important;
  }
  .buton-contnue {
    width: 272px;
  }
  .img {
    width: 40px;
  }
  .banda {
    width: 300px;
  }

  .hearts {
    margin-top: 22px;
    margin-bottom: 22px;
  }
}

.counter-timer {
  display: flex;
  align-content: center;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  height: 52px;
  border-radius: 0px;
  margin: -2px !important;
}

.v-dialog {
  margin: 0px !important;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  backdrop-filter: blur(25px);
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  &.mobile {
    overflow-y: auto;
    align-items: baseline !important;
  }
}

</style>
